// removed by extract-text-webpack-plugin
module.exports = {"list":"list__1CoWH"};


//////////////////
// WEBPACK FOOTER
// ./components/PrivacyPolicy/style.css
// module id = +R/T
// module chunks = 0